import React from 'react';
import SellsPoint from '../Request/RequestListToBePrepared';
import PdvMainMenu from '../../Pages/PdvMainMenu.js';
import style from '../../assets/styles/pdv.module.scss';
import Title from '../title.js';
import { Link } from 'react-router-dom';
import RequestModal from './requestModal.js';
import { GlobalContext } from '../../GlobalContext.js';
//import WarningAmoutMessage from '../Messages/WarningAmoutMessage.js';
import WarningAmoutMessage from '../Messages/WarningAmoutMessage';
import { checkUnavaiableRawMaterial } from '../../Helpers/Helpers.js';
import { isAudioMuted, toggleAudioMuted, playStatusChangeAlert } from '../../Helpers/soundAlerts.js';

const PDV = () => {
  const global = React.useContext(GlobalContext);
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 1000);
  const [isTransitioning, setIsTransitioning] = React.useState(false);
  const [isMuted, setIsMuted] = React.useState(isAudioMuted());
  
  const [manualTableNumber, setManualTableNumber] = React.useState('');
  
  React.useEffect(() => {
    localStorage.setItem('pdv', 'true');
    localStorage.setItem('isToten', 'false');
    document.body.style.overflowY = 'auto';
    const handleResize = () => setIsMobile(window.innerWidth < 1000);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggleSound = () => {
    const nextState = toggleAudioMuted();
    setIsMuted(nextState);
    if (!nextState) {
      playStatusChangeAlert(); // Teste sonoro imediato ao ativar
    }
  };

  const startTransition = (targetView) => {
    if (global.pdvMobileView === targetView) return;
    setIsTransitioning(true);
    global.setPdvMobileView(targetView);
    setTimeout(() => {
      setIsTransitioning(false);
    }, 500); // Tempo sintonizado com o SCSS
  };

  const toggleView = () => {
    startTransition(global.pdvMobileView === 'menu' ? 'orders' : 'menu');
  };

  return (
    <div className={style.mainWrapper}>
      <div className={style.fixedHeader}>
        <Link to="/admin/admin" className={style.btnBack} title="Sair do Módulo">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
        </Link>
        <Link to="/admin/admin" className={style.titleLink} style={{ textDecoration: 'none' }}>
          <Title mainTitle="Ponto de Venda" />
        </Link>
        <WarningAmoutMessage />
        
        <button 
          type="button"
          onClick={handleToggleSound}
          title={isMuted ? "Alertas sonoros desativados (clique para ativar)" : "Alertas sonoros ativados (clique para silenciar ou testar)"}
          className={style.soundBtn}
          style={{
            background: isMuted ? 'rgba(239, 83, 80, 0.15)' : 'rgba(46, 125, 50, 0.12)',
            border: isMuted ? '1px solid #ef5350' : '1px solid #66bb6a',
            color: isMuted ? '#c62828' : '#2e7d32',
          }}
        >
          {isMuted ? '🔇 Mudo' : '🔔 Som On'}
        </button>

        {isMobile && (
          <p 
            className={style.viewToggle} 
            onClick={toggleView}
          >
           {global.pdvMobileView === 'orders' ? 'CARDAPIO' : 'PEDIDOS'}
          </p>
        )}
      </div>

      <div className={`${style.pdvContainer} ${isMobile ? style.mobileMode : ''} ${isMobile && global.pdvMobileView === 'orders' ? style.showOrders : ''}`}>
        <div className={`${style.viewSection} ${isMobile && global.pdvMobileView === 'orders' ? style.hide : ''}`}>
          <PdvMainMenu 
            manualTableNumber={manualTableNumber} 
            setManualTableNumber={setManualTableNumber} 
          />
        </div>
        <div className={`${style.viewSection} ${isMobile && global.pdvMobileView === 'menu' ? style.hide : ''}`}>
          <SellsPoint />
        </div>
      </div>
    </div>
  );
};
export default PDV;
